import { useMutation } from "@tanstack/react-query";
import { fileControllerTimeoutStaleFileParses } from "../lib/gen-api";

export const useFileParseTimeout = () => {
  const { mutateAsync: timeoutStaleFileParses, isPending } = useMutation({
    mutationFn: async () => {
      const result = await fileControllerTimeoutStaleFileParses();
      if (!result.response.ok || !result.data) {
        throw new Error("Failed to time out stale file parses");
      }
      return result.data;
    },
  });

  return { timeoutStaleFileParses, isPending };
};
